import React, { useState } from "react";
export default function BigLiqBanner({ events, coin }) {
  const [dismissed, setDismissed] = useState(false);
  if (!events?.length || dismissed) return null;
  const top = events[0];
  const sk = top.side?.toLowerCase().includes("buy") ? "롱" : "숏";
  return (
    <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",
      padding:"8px 20px",background:"rgba(239,68,68,.12)",borderBottom:"1px solid rgba(239,68,68,.3)" }}>
      <span style={{ fontSize:13,color:"#fca5a5" }}>
        ⚡ <strong style={{ color:"#ef4444" }}>{coin} 대형 청산!</strong>
        {" "}{sk} ${(top.usd/1e6).toFixed(2)}M
        {events.length>1&&` 외 ${events.length-1}건`}
      </span>
      <button onClick={() => setDismissed(true)}
        style={{ background:"none",border:"none",color:"#6b7280",cursor:"pointer",fontSize:18 }}>×</button>
    </div>
  );
}
